var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrimeLocationDot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.723,
    height: 15.517,
    viewBox: "0 0 11.723 15.517",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    d: "M7.308,5.854A1.454,1.454,0,1,1,5.847,4.407,1.454,1.454,0,0,1,7.308,5.854m4.415.007h0c0,2.648-3.572,7.363-5.138,9.308a.927.927,0,0,1-1.3.144.98.98,0,0,1-.144-.144C3.544,13.224,0,8.509,0,5.861a5.861,5.861,0,0,1,11.723,0m-3.423,0A2.433,2.433,0,0,0,5.861,3.437H5.84A2.442,2.442,0,1,0,8.3,5.861",
    fill: "#CD0000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrimeLocationDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prime-location-dot.ab579b43628aba04690666f7d2a64596.svg";